import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { issues } from './models/issue';

@Injectable({
  providedIn: 'root',
})
export class IssueResolver {
  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return issues.get(Number.parseInt(route.params.issueType, 10));
  }
}
